import { useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import analytics from 'shared/utility/analytics';
import { Hyperlink } from 'shared/buttons';
import { Heading, LabelText, Info } from 'shared/components';
import { CurrencyInput } from 'shared/inputs';
import { InputsContainer } from 'shared/containers';
import { sync } from 'shared/wizard/actions';

const WizardCurrent = () => {
  const dispatch = useDispatch();
  const {
    input: { current_mortgage_amount, current_house_value },
    output: { errors },
  } = useSelector(state => state);

  useEffect(() => {
    analytics.send('Navigeer', 'Huidige situatie');
  }, []);

  return (
    <>
      <Heading>Huidige situatie</Heading>
      <InputsContainer>
        <LabelText>
          Wat is op dit moment de hoogte van je hypotheek? (je restschuld)
          <Info title="Hoogte van je hypotheek op dit moment">
            Heeft je hypotheek een gegarandeerde aflossing dan is de hoogte ervan nu lager dan op de ingangsdatum. Ook
            heb je misschien (extra) afgelost met eigen geld. Je vindt de huidige waarde (restschuld) binnen je digitale
            &apos;mijn omgeving&apos; van je hypotheekverstrekker of in de jaaropgave van je bank.
          </Info>
        </LabelText>
        <CurrencyInput
          onChange={sync(dispatch)('current_mortgage_amount')}
          value={current_mortgage_amount}
          errors={errors.current_mortgage_amount}
          placeholder="Bedrag"
        />
        <LabelText>
          Wat is op dit moment de waarde van je woning?
          <Info title="Wat is je woning op dit moment waard?">
            Weet je niet wat je woning op dit moment waard is? Via het{' '}
            <Hyperlink href="https://www.wozwaardeloket.nl/">WOZ Waardeloket</Hyperlink> kun je de huidige WOZ waarde
            opvragen. Je kunt ook de originele taxatiewaarde hanteren. Via deze waarde bepalen we of je misschien iets
            kunt besparen.
          </Info>
        </LabelText>
        <CurrencyInput
          onChange={sync(dispatch)('current_house_value')}
          value={current_house_value}
          errors={errors.current_house_value}
          placeholder="Bedrag"
        />
      </InputsContainer>
    </>
  );
};

export default WizardCurrent;
